import { Stack } from "@mui/material";
type TemplateLayerProps = {
  templateImage: string;
  backgroundSize?: string;
  backgroundPosition?: any;
};
export const TemplateLayer = ({
  templateImage,
  backgroundSize,
  backgroundPosition,
}: TemplateLayerProps) => {
  return (
    <Stack
      sx={{
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        backgroundImage: `url(${templateImage})`,
        //opacity: 0.8,
        backgroundSize: backgroundSize || "100% 100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: backgroundPosition || "center center",
        maxWidth: "100%",
        width: "100%",
      }}
    ></Stack>
  );
};
